import React, { useState } from 'react'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import AddPromotionModal from '../../components/admin/AddPromotionModal'
import ViewButton from '../../components/common/ViewButton'
import { useFilters } from '../../hooks/useFilters'

const AdminPromotionsPage = () => {
  const { filters, renderPagination } = useFilters()
  const { data: promotionsData } = useQuery({
    queryKey: QueryKeys.adminListPromotions(filters),
    queryFn: () => handleGetRequest('/admins/promotions', filters),
  })
  const promotions = promotionsData?.data || []
  const [addModalOpen, setAddModalOpen] = useState(false)

  return (
    <div className="p-2">
      <div className="flex items-center justify-end mb-4">
        <button
          className="bg-secondary-600 text-white rounded px-4 py-2 font-medium shadow hover:opacity-90 transition"
          type="button"
          onClick={() => setAddModalOpen(true)}
        >
          Add Promotion
        </button>
      </div>
      <div className="border border-gray-300 border-t-0 rounded-b-md overflow-hidden">
        <table className="w-full text-left">
          <thead>
            <tr className="bg-secondary-100 [&>th]:px-6 [&>th]:py-4 [&>th]:font-medium [&>th]:text-black [&>th]:text-base">
              <th>Banner Image</th>
              <th>Link</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {promotions.map((promotion) => (
              <tr
                key={promotion.id}
                className="border-t border-gray-200 last:border-b-0 [&>td]:px-6 [&>td]:py-4"
              >
                <td>
                  <img
                    src={promotion.bannerImage}
                    alt="Promotion Banner"
                    className="h-12 w-auto rounded border"
                  />
                </td>
                <td>
                  <a
                    href={promotion.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline break-all"
                  >
                    {promotion.link}
                  </a>
                </td>
                <td>
                  <div className="flex justify-start gap-2">
                    <ViewButton redirectPath={`/admin/promotions/${promotion.id}`} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {renderPagination(promotionsData?.meta)}
      <AddPromotionModal isOpen={addModalOpen} onClose={() => setAddModalOpen(false)} />
    </div>
  )
}

export default AdminPromotionsPage
